// src/main.ts (or your entry file)

import { createApp } from 'vue'; // Import createApp from Vue 3
import App from './PlanTrail.vue'; // Your root component
import store from "./store/store"; // Your Vuex store
import { i18n } from '../../i18n';

declare global {
  interface Window {
    // map and geoLocate are primarily managed within PlanTrail.vue now,
    // but declare them here if accessed globally elsewhere.
    map?: mapboxgl.Map; // Optional as it's set later
    geoLocate?: mapboxgl.GeolocateControl; // Optional

    // Keep other existing global declarations if needed by other scripts
    user?: any;
    onBoardingVue?: any;
    bus?: any; // For the event bus
    importRouteMultipleOptionsDialogShow?: (lineStrings: any[]) => void;
  }
}

const mountElement = document.querySelector('#hike');

if (mountElement) {
  const app = createApp(App);
  app.use(store);
  app.use(i18n);
  app.mount('#hike');

} else {
  console.warn("Mount element '#hike' not found. Vue app not mounted.");
}
